import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../components/DarkMode';
import jsonData from "../data/tech-stack.json";
import '../assets/styles/pages.css';

const About = () => {
  const { isDarkMode } = useDarkMode();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [techStackData, setTechStackData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Fetch JSON data from file
    const fetchTechStackData = async () => {
      try {
        // Import the JSON data
        setTechStackData(jsonData);
      } catch (error) {
        console.error('Error fetching tech stack data:', error);
      }
    };

    fetchTechStackData();

    // Check if screen size is mobile
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize); // Listen for resize events

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const calculateDate = () => new Date().getFullYear() - 2018;

  const handleModalOpen = () => setIsModalOpen(true);

  const handleModalClose = () => setIsModalOpen(false);

  return (
    <div className={`container mx-auto m-4 border ${isDarkMode ? 'border-gray-300' : 'border-black'}`} id="about">
      <div id="about-content">
        <div id="about-title">
          <h1 className='text-4xl text-center sm:text-center'>About</h1>
        </div>
        <div id="main-content">
          <div id="about-description">
            <p className="leading-relaxed mb-4">
              A test engineer who also have a heart and soul for Software Engineering and AI. I am on mission to build a scalable open-source automated software solution that can cater all the needs of all QE/QA/Testers out there. My other interests are Backend (Python), Frontend Web Development using ReactJS with Tailwind CSS, DevOps / SRE services and last is my current pursuit in AI Technology.
            </p>
            <p className="leading-relaxed mb-4">
              For my professional experience, been in the industry for about {calculateDate()} year and specialized in Free and Open-Source Software (FOSS) technology, I bring extensive expertise in Software Engineering across diverse industries and projects, including Real Estate, Healthcare, E-commerce, Consulting, POS, Inventory Management, Taxation, and more. My experience spans various roles, from Senior and Lead positions to Consultant, where I've actively contributed to the hiring process, provided leadership, and managed teams.
            </p>
            <p className="leading-relaxed mb-4">
              Have a proven track record of building Test Automation Frameworks and leading QA Teams from inception, aligning with Agile and Scrum methodologies. This approach enables us to maximize testing capabilities, streamline test efforts, and expedite the testing process, all while maintaining a strong Agile and Scrum mindset that aligns with the Software Testing Life Cycle.
            </p>
            <p className="leading-relaxed mb-4">
              Additionally, I excel in integrating Test Automation into DevOps practices, particularly within Continuous Integration/Continuous Deployment (CI/CD) pipelines. This integration ensures seamless coordination between development and testing teams, encompassing environments, builds, tests, and releases, thus fostering efficient collaboration and accelerated delivery cycles.
            </p>
          </div>
          <div className='text-center sm:text-left' id="about-certifications">
            <p>
              Certification
            </p>
            <a href="https://learn.microsoft.com/en-us/users/christianfernandez-0162/credentials?tab=credentials-tab" target="_blank" rel="noopener noreferrer">
              <button className='text-blue-500 underline cursor-pointer'>
                Microsoft Certification
              </button>
            </a>
          </div>
          <div className="text-center sm:text-left" id="about-technologies">
            <p>
              Here are some of the technologies and tools:
            </p>
            <button onClick={handleModalOpen} className="text-blue-500 underline cursor-pointer">Technology Stack</button>
            {isModalOpen && (
              <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-lg overflow-auto">
                <div className={`p-6 rounded-lg ${isDarkMode ? 'bg-neutral-900' : 'bg-white'} animate-fade-in transition-opacity duration-300 ${isMobile ? 'flex flex-col' : 'flex-row'}`}>
                  <div className={isMobile ? '' : 'mr-6'}>
                    <h1 className='text-4xl font-bold mb-4'>
                     Tech-Stack
                    </h1>
                    <div className={`grid ${isMobile ? 'grid-cols-1 overflow-y-scroll' : 'grid-cols-4'} gap-10 text-center`} style={{ maxHeight: '80vh'}}>
                      {techStackData.map((column, index) => (
                        <div key={index} className="border-y border-x pl-1 pr-1 pt-1 pb-1 w-full mx-auto">
                          <h2 className="text-2xl font-semibold mb-5">{column.title}</h2>
                          <ul>
                            {column.items.map((item, itemIndex) => (
                              <li key={itemIndex}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-10 md:mt-10 md:pl-6">
                    <button onClick={handleModalClose} className="px-4 py-2 bg-blue-500 text-white rounded-md">Close</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
